import type { SVGProps } from 'react';

export const X = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.43 16.959h-1.758l-7.1-9.918h1.757l7.1 9.918Z" />
      <path d="M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16Zm-9.923 12.835-5.104 5.46h1.843l4.061-4.343 3.108 4.343h5.042l-5.296-7.398 4.855-5.192h-1.843l-3.81 4.076-2.918-4.076H4.973l5.104 7.13Z" />
    </svg>
  );
};
